module.exports = __webpack_public_path__ + "media/soundtrack.647e333a.mp3";